import { ProfileContext } from 'decorators/User'
import { useContext } from 'react'

export const useProfile = () => useContext(ProfileContext)
